// extracted by mini-css-extract-plugin
module.exports = {"root":"TableHeading_root__EkWnD","clinicsSelect":"TableHeading_clinicsSelect__3_jdc"};